export const OTP_DELIVERY_CHANNELS = ['sms', 'call'] as const

export type OtpDeliveryChannel = typeof OTP_DELIVERY_CHANNELS[number]

export function withOtpDeliveryChannel<T extends Record<string, unknown>>(
  payload: T,
  channel?: OtpDeliveryChannel,
): T | (T & { channel: OtpDeliveryChannel }) {
  return channel ? { ...payload, channel } : payload
}
